"use client";

import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@repo/design-system/components/ui/accordion";
import { useLanguage } from "~/translations/loader/use-language";

/**
 * FAQ2 - Three columns: Recruiting Day, Conditions & Benefits, Students
 * Uses econ_faq_2-4 translations
 */
export default function FAQ2Econ() {
  const $ = _c(51);
  const t = useLanguage();
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== t.econ_faq_2_a1 || $[1] !== t.econ_faq_2_a2 || $[2] !== t.econ_faq_2_a3 || $[3] !== t.econ_faq_2_a4 || $[4] !== t.econ_faq_2_q1 || $[5] !== t.econ_faq_2_q2 || $[6] !== t.econ_faq_2_q3 || $[7] !== t.econ_faq_2_q4 || $[8] !== t.econ_faq_3_a1 || $[9] !== t.econ_faq_3_a2 || $[10] !== t.econ_faq_3_a3 || $[11] !== t.econ_faq_3_q1 || $[12] !== t.econ_faq_3_q2 || $[13] !== t.econ_faq_3_q3 || $[14] !== t.econ_faq_4_a1 || $[15] !== t.econ_faq_4_a2 || $[16] !== t.econ_faq_4_a3 || $[17] !== t.econ_faq_4_a4 || $[18] !== t.econ_faq_4_a5 || $[19] !== t.econ_faq_4_q1 || $[20] !== t.econ_faq_4_q2 || $[21] !== t.econ_faq_4_q3 || $[22] !== t.econ_faq_4_q4 || $[23] !== t.econ_faq_4_q5 || $[24] !== t.econ_faq_HL || $[25] !== t.econ_faq_section2_HL || $[26] !== t.econ_faq_section3_HL || $[27] !== t.econ_faq_section4_HL) {
    const faq1 = [{
      question: t.econ_faq_2_q1,
      answer: t.econ_faq_2_a1
    }, {
      question: t.econ_faq_2_q2,
      answer: t.econ_faq_2_a2
    }, {
      question: t.econ_faq_2_q3,
      answer: t.econ_faq_2_a3
    }, {
      question: t.econ_faq_2_q4,
      answer: t.econ_faq_2_a4
    }];
    const faq2 = [{
      question: t.econ_faq_3_q1,
      answer: t.econ_faq_3_a1
    }, {
      question: t.econ_faq_3_q2,
      answer: t.econ_faq_3_a2
    }, {
      question: t.econ_faq_3_q3,
      answer: t.econ_faq_3_a3
    }];
    const faq3 = [{
      question: t.econ_faq_4_q1,
      answer: t.econ_faq_4_a1
    }, {
      question: t.econ_faq_4_q2,
      answer: t.econ_faq_4_a2
    }, {
      question: t.econ_faq_4_q3,
      answer: t.econ_faq_4_a3
    }, {
      question: t.econ_faq_4_q4,
      answer: t.econ_faq_4_a4
    }, {
      question: t.econ_faq_4_q5,
      answer: t.econ_faq_4_a5
    }];
    const renderFaqSection = _temp2;
    t6 = "outer-container bg-white py-container text-foreground print:hidden";
    t7 = "faq2";
    t4 = "inner-container";
    if ($[36] !== t.econ_faq_HL) {
      t5 = <h2 className="mb-10 text-center font-bold text-4xl xl:mb-20 xl:text-5xl" data-source="lc">{t.econ_faq_HL}</h2>;
      $[36] = t.econ_faq_HL;
      $[37] = t5;
    } else {
      t5 = $[37];
    }
    t0 = "grid auto-cols-fr gap-y-8 lg:grid-flow-col xl:gap-x-4";
    t1 = renderFaqSection(t.econ_faq_section2_HL, faq1);
    t2 = renderFaqSection(t.econ_faq_section3_HL, faq2);
    t3 = renderFaqSection(t.econ_faq_section4_HL, faq3);
    $[0] = t.econ_faq_2_a1;
    $[1] = t.econ_faq_2_a2;
    $[2] = t.econ_faq_2_a3;
    $[3] = t.econ_faq_2_a4;
    $[4] = t.econ_faq_2_q1;
    $[5] = t.econ_faq_2_q2;
    $[6] = t.econ_faq_2_q3;
    $[7] = t.econ_faq_2_q4;
    $[8] = t.econ_faq_3_a1;
    $[9] = t.econ_faq_3_a2;
    $[10] = t.econ_faq_3_a3;
    $[11] = t.econ_faq_3_q1;
    $[12] = t.econ_faq_3_q2;
    $[13] = t.econ_faq_3_q3;
    $[14] = t.econ_faq_4_a1;
    $[15] = t.econ_faq_4_a2;
    $[16] = t.econ_faq_4_a3;
    $[17] = t.econ_faq_4_a4;
    $[18] = t.econ_faq_4_a5;
    $[19] = t.econ_faq_4_q1;
    $[20] = t.econ_faq_4_q2;
    $[21] = t.econ_faq_4_q3;
    $[22] = t.econ_faq_4_q4;
    $[23] = t.econ_faq_4_q5;
    $[24] = t.econ_faq_HL;
    $[25] = t.econ_faq_section2_HL;
    $[26] = t.econ_faq_section3_HL;
    $[27] = t.econ_faq_section4_HL;
    $[28] = t0;
    $[29] = t1;
    $[30] = t2;
    $[31] = t3;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
  } else {
    t0 = $[28];
    t1 = $[29];
    t2 = $[30];
    t3 = $[31];
    t4 = $[32];
    t5 = $[33];
    t6 = $[34];
    t7 = $[35];
  }
  let t8;
  if ($[38] !== t0 || $[39] !== t1 || $[40] !== t2 || $[41] !== t3) {
    t8 = <div className={t0}>{t1}{t2}{t3}</div>;
    $[38] = t0;
    $[39] = t1;
    $[40] = t2;
    $[41] = t3;
    $[42] = t8;
  } else {
    t8 = $[42];
  }
  let t9;
  if ($[43] !== t4 || $[44] !== t5 || $[45] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[43] = t4;
    $[44] = t5;
    $[45] = t8;
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  let t10;
  if ($[47] !== t6 || $[48] !== t7 || $[49] !== t9) {
    t10 = <section className={t6} id={t7}>{t9}</section>;
    $[47] = t6;
    $[48] = t7;
    $[49] = t9;
    $[50] = t10;
  } else {
    t10 = $[50];
  }
  return t10;
}
function _temp2(title, faqs) {
  return <div><h3 className="mb-4 font-bold text-primary text-xl" data-source="lc">{title}</h3><Accordion className="space-y-1" collapsible={true} type="single">{faqs.map(_temp)}</Accordion></div>;
}
function _temp(entry) {
  return <AccordionItem className="border-0" key={entry.question} value={entry.question}><AccordionTrigger className="cursor-pointer gap-4 bg-gray-100 p-3 text-left font-bold text-lg hover:text-primary hover:no-underline" data-source="lc" icon="cross" iconClassName="text-primary">{entry.question}</AccordionTrigger><AccordionContent className="bg-gray-100 px-3 pb-3"><div className="text-lg [&_li]:mb-1 [&_p]:mb-2 [&_ul]:list-disc [&_ul]:pl-5" dangerouslySetInnerHTML={{
        __html: entry.answer
      }} data-source="lc" /></AccordionContent></AccordionItem>;
}